import { Query } from '@/lib/generated/graphql-types'
import { GET_SALARY_HISTOGRAM_DATA } from '@/modules/salary/queries'
import { getSalaryHistogramInput } from '@/modules/salary/common/get-salary-histogram-input'
import { useSuspenseQuery } from '@apollo/client'
import { SalaryFilterParam } from '../constants'
import { useSearchParams } from 'next/navigation'
import { SalaryPayPeriod } from '../table/constants'
import { useSalaryParams } from '../common/use-salary-params'

export function useSalaryHistogram() {
  const { jobType, occupationSlug, location } = useSalaryParams()
  const searchParams = useSearchParams()
  const payPeriod = searchParams.get(SalaryFilterParam.payPeriod)

  const input = getSalaryHistogramInput({
    jobType,
    occupationSlug,
    location,
    payPeriod: payPeriod as SalaryPayPeriod | null,
  })
  // do not skip here, as it needs to match exactly the same as the
  // PreloadQuery on the salary/page.tsx file
  return useSuspenseQuery<Pick<Query, 'getHistogram'> | undefined>(
    GET_SALARY_HISTOGRAM_DATA,
    {
      variables: {
        input,
      },
    },
  )
}
